// extracted by mini-css-extract-plugin
var _1 = "AuthFormWrapper-moduleAuthFormWrapper__xrPe3";
export { _1 as "AuthFormWrapper" }
